import React, { useState } from "react";
import MUIDataTable from "mui-datatables";

import { useTranslation } from "react-i18next";


export default function UseTable(props) {
  const { t } = useTranslation();
  const [selectedContact, SetSelectedContact] = useState([]);
  const [searchBtn, setSearchBtn] = useState(true);
  const [downloadBtn, setDownloadBtn] = useState(true);
  const [printBtn, setPrintBtn] = useState(true);

  const [filterBtn, setFilterBtn] = useState(true);

  const columns = props.columns;
  const data = props.data;
  const title = props.title;
  const selectableRows = props.selectableRows;
  const expandableRows = props.expandableRows;
  const renderExpandableRow = props.renderExpandableRow;
  const  customToolbarSelect=props.customToolbarSelect;

  const options = {
    serverSide: false,
    expandableRows: expandableRows,
    expandableRowsHeader: false,
    expandableRowsOnClick: true,
    customToolbarSelect: customToolbarSelect,
    isRowExpandable: (dataIndex, expandedRows) => {
      if (dataIndex === 3 || dataIndex === 4) return true;

      // Prevent expand/collapse of any row if there are 4 rows expanded already (but allow those already expanded to be collapsed)
      if (
        expandedRows.data.length > 4 &&
        expandedRows.data.filter((d) => d.dataIndex === dataIndex).length === 0
      )
        return false;
      return true;
    },
    // rowsExpanded: [0, 1],
     renderExpandableRow: renderExpandableRow,
    
    onRowExpansionChange: (curExpanded, allExpanded, rowsExpanded) =>
      console.log(curExpanded, allExpanded, rowsExpanded),
    onTableChange: (action, tableState) => {
      this.xhrRequest("my.api.com/tableData", (result) => {
        this.setState({ data: result });
      });
    },
    search: searchBtn,
    download: downloadBtn,
    print: printBtn,

    filter: filterBtn,
    filterType: "dropdown",

    selectableRows: selectableRows,

    onRowSelectionChange: props.onRowSelectionChange,

    // customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (<CustomToolbarSelect selectedRows={selectedRows} />),
    onTableChange: (action, state) => {
      console.log(action);
      console.dir(state);
    },
    textLabels: {
      body: {
        noMatch: t("sorry,noMatchingRecordsFound"),
        toolTip: t("sort"),
        columnHeaderTooltip: (column) => `${t("sortFor")} ${column.label}`,
      },
      pagination: {
        next: t("nextPage"),
        previous: t("previousPage"),
        rowsPerPage: t("RowsPerPage:"),
        displayRows: t("of"),
      },
      toolbar: {
        search: t("search"),
        downloadCsv: t("downloadCSV"),
        print: t("print"),
        viewColumns: t("viewColumns"),
        filterTable: t("filterTable"),
      },
      filter: {
        all: t("all"),
        title: t("filters"),
        reset: t("reset"),
      },
      viewColumns: {
        title: t("showColumns"),
        titleAria: t("show/hideTable Columns"),
      },

      selectedRows: {
        text: t("row(s)Selected"),
        delete: t("delete"),
        deleteAria: t("deleteSelectedRows"),
      },
    },
  };

  return (
    <>
      <MUIDataTable
        title={title}
        data={data}
        columns={columns}
        options={options}
      />
    </>
  );
}
